<template>
    <section :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-white'" class="tw-sticky tw-top-0 tw-z-10">
        <div class="tw-mx-auto tw-px-6 tw-py-4 tw-flex tw-justify-between tw-items-center">
            <div class="tw-flex tw-gap-6 tw-items-center">
                <div>
                    <h2 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-slate-900'" class="tw-align-middle tw-text-2xl tw-font-bold tw-uppercase">{{ unidade.nome }}</h2>
                </div>
                <div class="tw-flex tw-items-center tw-gap-3">
                    <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-600'" class="tw-text-xs tw-uppercase tw-tracking-wider">Status:</p>
                    <div :class="unidadeStatus === 'SUCESSO' ? (theme === 'dark' ? 'tw-bg-emerald-500/10 tw-text-emerald-400' : 'tw-bg-emerald-50 tw-text-emerald-600') : (theme === 'dark' ? 'tw-bg-red-500/10 tw-text-red-400' : 'tw-bg-red-50 tw-text-red-600')" class="tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-semibold tw-uppercase">
                        {{ (unidadeStatus ? unidadeStatus : 'FALHA') }}
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { ref, watch, nextTick, computed } from 'vue';
import { useStore } from 'vuex';

export default {
    setup () {
        const vue_app_name = process.env.VUE_APP_NAME;
        const version = process.env.VUE_APP_VERSION;
        const store = useStore();
        const unidade = ref({});
        const unidadeStatus = ref('');

        const getStatus = async () => {
            try{
                const response = await store.dispatch('unidade/getServicoStatus', unidade.value.id)
                if (response.data.consumers == 0 || response.data.messages > 1) {
                    unidadeStatus.value = 'FALHA'
                } else {
                    unidadeStatus.value = 'SUCESSO'
                }
            } catch (error) {
                console.error('Erro ao obter status do serviço:', error);
            }
        };

        watch(() => store.state.unidade.unidade, async (newUnidade) => {
				unidade.value = newUnidade;
                await nextTick();
                getStatus();
			}, { immediate: true }
		);

        const theme = computed(() => store.state.ui.theme);

        return {
            vue_app_name,
            version,
            unidade,
            unidadeStatus,
            theme
        }
    }
}
</script>